module.exports = __webpack_public_path__ + "img/EmptyInbox.4235e0ad.svg";